import React, { Component } from 'react'
import { connect } from 'react-redux'
import blutacho from '../assets/img/brand/logo-transparent.png'
import { __ } from '../services/translate'
import {
  Container,
  ErrorMessage,
  Input,
  LanguageContainer,
  Link,
  LoginContainer,
  Logo,
  Overlay,
  Wrapper
} from '../components/Login'
import { Button } from '../components/Common/Button'
import { loginGuest, loginUser } from '../actions/user'
import SelectPicker from '../components/Common/SelectPicker'
import { setLanguage } from '../actions/locale'

class Login extends Component {
  state = {
    driverNumber: ''
  }

  onChange = e => this.setState({ driverNumber: e.target.value })

  keyPress = (e) => {
    const { driverNumber } = this.state
    if (e.key === 'Enter' && driverNumber.trim()) {
      this.props.login(driverNumber.trim())
    }
  }

  login = () => {
    const { driverNumber } = this.state
    if (driverNumber.trim()) {
      this.props.login(driverNumber.trim())
    }
  }

  render() {
    return (
      <Wrapper className="login-page">
        <Overlay/>
        <LanguageContainer>
          <SelectPicker
            renderOption={language => language.name}
            selected={this.props.selectedLanguageId}
            onSelect={language => this.props.setLanguage(language)}
            options={this.props.languages}
          />
        </LanguageContainer>
        <Container>
          <Logo src={blutacho}/>
          <LoginContainer>
            {this.props.error && <ErrorMessage>{this.props.error}</ErrorMessage>}
            <Input
              placeholder={__('Číslo karty řidiče')}
              info={__('Pokud nejsi držitelem karty řidiče, po registraci obdržíš přihlašovací údaje do e-mailu')}
              value={this.state.driverNumber}
              onChange={this.onChange}
              onKeyPress={this.keyPress}
            />
            <Button onClick={this.login}>
              {__('Přihlásit se')}
            </Button>
            <Link onClick={this.props.loginGuest}>
              {__('Pokračovat bez přihlášení')}
            </Link>
          </LoginContainer>
        </Container>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state) => ({
  languages: state.locale.languages,
  selectedLanguageId: state.locale.selectedLanguage.id,
  error: state.user.error,
})

const mapDispatchToProps = (dispatch) => ({
  loginGuest: () => dispatch(loginGuest()),
  login: (driverNumber) => dispatch(loginUser(driverNumber)),
  setLanguage: (language) => dispatch(setLanguage(language)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
